import {Swiper}        from 'swiper';
import {SwiperOptions} from 'swiper/types';

function mostReadSlider() {

  const left  = document.getElementById('most-read-previous') as HTMLElement;
  const right = document.getElementById('most-read-next') as HTMLElement;
  
  let options: SwiperOptions = {
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: false,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  }

  let slider = new Swiper('.most-read-container', options);

  left.addEventListener('click', () => slider.slidePrev());
  right.addEventListener('click', () => slider.slideNext());
}

mostReadSlider();

